import actions from './customerActions';
import mutations from './customerMutations';
import getters from './customerGetters';

const state = {
  items: [],
  filter: {
    active: true
  }
};

export default {
  namespaced: true,
  state,
  mutations: mutations,
  getters: getters,
  actions: actions
}



// WEBPACK FOOTER //
// ./client/store/modules/customer/index.js